"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
import { useArticleData } from "../../context/ArticleDataContext";
import { DetailedMatchCard } from "@/blocks/SportsMatchCard/frontend/DetailedMatchCard/DetailedMatchCard";
import { useNavigation } from "@/lib/navigation/NavigationProvider";
export function ArticleMatchDetail() {
  const $ = _c(14);
  const {
    getEntitiesByType
  } = useArticleData();
  const nav = useNavigation();
  let T0;
  let t0;
  let t1;
  let t2;
  let t3;
  if ($[0] !== getEntitiesByType || $[1] !== nav) {
    t3 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const matchEntities = getEntitiesByType("match");
      if (matchEntities.length === 0) {
        t3 = null;
        break bb0;
      }
      const matchId = matchEntities[0].entityId;
      t2 = "mt-8";
      T0 = DetailedMatchCard;
      t0 = matchId;
      t1 = nav.match(matchId);
    }
    $[0] = getEntitiesByType;
    $[1] = nav;
    $[2] = T0;
    $[3] = t0;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    T0 = $[2];
    t0 = $[3];
    t1 = $[4];
    t2 = $[5];
    t3 = $[6];
  }
  if (t3 !== Symbol.for("react.early_return_sentinel")) {
    return t3;
  }
  let t4;
  if ($[7] !== T0 || $[8] !== t0 || $[9] !== t1) {
    t4 = <T0 matchId={t0} matchUrl={t1} />;
    $[7] = T0;
    $[8] = t0;
    $[9] = t1;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t2 || $[12] !== t4) {
    t5 = <div className={t2}>{t4}</div>;
    $[11] = t2;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
}